import { render } from "./customer.vue?vue&type=template&id=319c69c2&ts=true"
import script from "./customer.vue?vue&type=script&lang=ts"
export * from "./customer.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__